/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mailbox_Pdf_Too_LargeInputs */

const fr_mailbox_pdf_too_large = /** @type {(inputs: Mailbox_Pdf_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un PDF de 12 Mo maximum.`)
};

const en_mailbox_pdf_too_large = /** @type {(inputs: Mailbox_Pdf_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a PDF no larger than 12 MB.`)
};

/**
* | output |
* | --- |
* | "Choose a PDF no larger than 12 MB." |
*
* @param {Mailbox_Pdf_Too_LargeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mailbox_pdf_too_large = /** @type {((inputs?: Mailbox_Pdf_Too_LargeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mailbox_Pdf_Too_LargeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mailbox_pdf_too_large(inputs)
	return fr_mailbox_pdf_too_large(inputs)
});